export default __webpack_public_path__ + "static/media/mobile-image.525f7c44.png";